import React,{useRef,useState,useEffect} from 'react';
import { Table,Modal} from "reactstrap";
import {DataTable} from '../../Components'
import { useNavigate } from 'react-router-dom';
import { Controller, set, useForm } from "react-hook-form";
import {MemberInfoCard} from '../../Components/Member';

import {NumberFormat,DateThaiFormat,DateThai, TimeFormat,APIURL} from '../../Utils/Function';
import {} from '../../Utils/Status'
import { createRoot } from 'react-dom/client';
import Swal from 'sweetalert2';
import API from '../../API';

import "react-datepicker/dist/react-datepicker.css";
import '../../Assets/CSS/TALFC.css';

const StaffHome =()=> {
    const RedirectTo = useNavigate()
    const { register, getValues, setValue } = useForm();
    const [ShiftStatus,setShiftStatus] = useState(false);
    const [ShiftDetail,setShiftDetail] = useState(null);
    const [ShiftSummary,setShiftSummary] = useState(null);
    const [ShiftAmount,setShiftAmount] = useState(0);

    const [CardSearch,setCardSearch] = useState(null);
    const [MemberDetail,setMemberDetail] = useState(null);
    const [CardDetail,setCardDetail] = useState(null);
    const [Topup,setTopup] = useState(null);
    const ref = useRef();
    const refTopup = useRef();
    const refSearch = useRef();
    const [_CloseShiftModel,setCloseShiftModel] = useState(false);
    const _MemberInfoCard = useRef();
    
    useEffect(() => {
            (async () => {
                //await _LoadCustomerGroupList();
                _CheckShiftIsOpen();
                setCloseShiftModel(false);
            })();
    
            return ()=>{ }
    }, []);
    

    const _CheckShiftIsOpen = async()=>{
        Swal.showLoading();

        API({method : "get",url:"/Shift/Status"}).then(res=>{
            Swal.close();
            if (!res.data.Status) {
                setShiftStatus(false);
            }else{
                setShiftStatus(true);
                localStorage.setItem("Shift", res.data.Data);
                _GetShift();
            }
        }).catch(res => {
            Swal.close();
            return;
        });
    }
    const _OpenShift = async()=>{
        Swal.fire({
            title: 'ระบุยอดเงินคงเหลือ',
            input: 'number',
            showCancelButton: true,
            confirmButtonText: 'เปิดรอบ',
            showLoaderOnConfirm: true,
            preConfirm: (value) => {
                API({method : "post", url:"/Shift/Start",data: {Balance:value }, headers: { "Content-Type": "multipart/form-data" }}).then(res=>{
                    if (!res.data.Status) {
                        Swal.fire({
                            title: res.data.Message,
                            icon: 'error'
                        });
                        return;
                    }
                    localStorage.setItem("Shift", res.data.Data);
                    setShiftStatus(true);
                    _GetShift();
                    Swal.fire({
                        title: 'เปิดรอบบัญชีสำเร็จ',
                        icon: 'success'
                    });
                }).catch(res => {
                    Swal.fire({
                        title: res,
                        icon: 'error'
                    });
                    return;
                });
              return value;
            },
            allowOutsideClick: () => !Swal.isLoading()
          }).then((result) => {
            if (result.isConfirmed) {
                //Swal.showLoading();
                
             
            }
        });
    }

    const _CloseShift = async()=>{
        Swal.showLoading();
        setShiftSummary(null);
        API({method : "get",url:"/Shift/"+localStorage.getItem("Shift")+"/Summary"}).then(res=>{
            Swal.close();
            if (!res.data.Status) {
                setShiftStatus(false);
                return;
            }
            setShiftSummary(res.data.Data);
            setCloseShiftModel(true);

        }).catch(res => {
            Swal.close();
            return;
        });
        return;
        
    }
    const _CloseShiftAction = async()=>{
        Swal.fire({
            icon: 'warning',
            title: "สรุปปิดรอบบัญชียอดเงิน "+NumberFormat(ShiftAmount)+" บาท ?",
            text : '',
            showCancelButton : true,
            confirmButtonText: 'ถูกต้อง',
            confirmButtonColor:'#d33',
            cancelButtonText:'ยกเลิก'
        }).then((r)=>{
            if(!r.isConfirmed){
                return;
            }
            setTimeout(()=>{
                Swal.showLoading();
                API({method : "post", url:"/Shift/"+localStorage.getItem("Shift")+"/End",data: {Balance:ShiftAmount }, headers: { "Content-Type": "multipart/form-data" }}).then(res=>{
                    if (!res.data.Status) {
                        Swal.fire({
                            title: res.data.Message,
                            icon: 'error'
                        });
                        return;
                    }
                    localStorage.setItem("Shift", res.data.Data);
                    setShiftStatus(true);
                    _GetShift();
                    Swal.fire({
                        title: 'ปิดรอบบัญชีสำเร็จ',
                        icon: 'success'
                    });
                    setShiftStatus(false);
                    setCloseShiftModel(false);
                    setShiftSummary(null);
                    setShiftAmount(null);
                }).catch(res => {
                    Swal.fire({
                        title: res,
                        icon: 'error'
                    });
                    return;
                });
            },200)
        });
    }
    const _GetShift = async()=>{
        API({method : "get",url:"/Shift/"+localStorage.getItem("Shift")}).then(res=>{
            if (res.data.Status) {
                setShiftDetail(res.data.Data);
                //localStorage.setItem("ShiftDetail", JSON.stringify(res.data.Data));
            }
        }).catch(res => {
            return;
        });  
    }

    const _Search = async(Search)=>{
        if(Search === "")return;
        Swal.showLoading();
        API({method : "post", url:"/Staff/Search",data: {Search:Search }, headers: { "Content-Type": "multipart/form-data" }}).then(res=>{
            if (!res.data.Status) {
                Swal.fire({
                    title: res.data.Message,
                    icon: 'error'
                });
                setCardSearch('');
                setMemberDetail(null);
                setCardDetail(null);
                setValue('MemberID',null);
                return;
            }
            setMemberDetail(res.data.Data.member);
            setCardDetail(res.data.Data.card);
            setValue('MemberID',res.data.Data.member.MemberId);
            setTimeout(()=>{
                refTopup.current.focus();
                refTopup.current.select();
            },500)
            Swal.close();
        }).catch(res => {
            Swal.fire({
                title: res,
                icon: 'error'
            });
            setCardSearch('');
            setMemberDetail(null);
            setCardDetail(null);
            setValue('MemberID',null);
            return;
        });
    }
    const _configs = {
        "order": [[0, "desc"]],
        pageLength: 5,
        orderMulti: true,
        lengthMenu:[5,10,20]
    }
    const _ajax  = {
        'url': '/Staff/Topup/List',
        'method': 'POST',
        'caches': false,
        'global': false,
        'data': function (d) {
            d.Shift = localStorage.getItem("Shift")
        }
    };

    const _Buttons = (d,r) => (
        <div className='btn-group btn-group-sm'>
            <button type='button' disabled={(r.Status == 1 ? false :true)} title='รายละเอียด' className='btn btn-danger text-white' onClick={() =>{_Refund(r);}}>ยกเลิก</button>
            <button type='button' title='รายละเอียด' className='btn btn-info text-white' onClick={() =>{_MemberInfoCard.current?.Show(r.MemberId)}}>Info</button>

        </div>
    )
    const _column = [
        {data: "Created", name: "Created", autoWidth: true,render(data){
            return DateThaiFormat(data,true);
        }},
        { data: "MemberCode", name: "MemberCode", autoWidth: true },
        { data: "Name", name: "Name", autoWidth: true },
        { data: "Amount", name: "Amount", autoWidth: true,render(data){
            return NumberFormat(data);
        } },
        { data: "AfterCredit", name: "AfterCredit", autoWidth: true,render(data){
            return NumberFormat(data);
        } },
        { data: "Status", name: "Status", autoWidth: true,render(data){
            switch(data){
                case 1 : return '<label class="text-success">เติมเงิน</label>';
                case 2 : return '<label class="text-danger">ยกเลิก</label>';
                default : return '-';
            };
        } },
        { data: "ReasonName", name: "ReasonName", autoWidth: true },
        {
            data: "TransactionID", name: "TransactionID", autoWidth: true,
            render: (data) => { return ''; },
            createdCell: (td, cellData,rowData) => createRoot(td).render(_Buttons(cellData,rowData))
        }
    ]
    const _ColumnDefs = [
    ]
    
    const _UpdateTable =()=>{
        ref.current?.load();
    }

    const _Topup = async(Amount)=>{
        if(Amount >= 100000){
            Swal.fire({
                title: 'ยอดเงินไม่ถูกต้อง',
                icon: 'error'
            });
            return;
        }
        Swal.fire({
            icon: 'warning',
            title: "เติมเงินจำนวน "+NumberFormat(Amount)+" บาท ?",
            text : 'รหัสประจำตัว '+MemberDetail.MemberCode,
            showCancelButton : true,
            confirmButtonText: 'ถูกต้อง',
            confirmButtonColor:'#d33',
            cancelButtonText:'ยกเลิก'
        }).then((r)=>{
            if(!r.isConfirmed){
                return;
            }
            setTimeout(()=>{
                Swal.showLoading();
                API({method : "post", url:"/Topup/"+localStorage.getItem("Shift")+"/"+MemberDetail.MemberId+"/"+(CardDetail != null ? CardDetail.CardNo : "00000000000000000000"),data: {Amount:Amount }, headers: { "Content-Type": "multipart/form-data" }}).then(res=>{
                    if (!res.data.Status) {
                        Swal.fire({
                            title: res.data.Message,
                            icon: 'error'
                        });
                        return;
                    }
                    setMemberDetail(null);
                    setCardDetail(null);
                    _Search(CardSearch)
                    setTopup(null);
                    setTimeout(() => {
                        ref.current?.load();
                        refSearch.current?.focus();
                    }, 500);
                    Swal.close();
                }).catch(res => {
                    Swal.fire({
                        title: res,
                        icon: 'error'
                    });
                    return;
                });
            },200)
        });

    }

    const _Refund = async(Obj)=>{
        console.log(Obj);
        Swal.fire({
                    icon: 'warning',
                    title: 'ต้องการยกเลิกรายการเติมเงิน '+NumberFormat(Obj.Amount)+' บาท ?',
                    text : Obj.MemberCode+' '+Obj.Name,
                    showCancelButton : true,
                    confirmButtonText: 'ตกลง',
                    confirmButtonColor:'#d33',
                    cancelButtonText:'ยกเลิก'
                }).then((r)=>{
                    if(!r.isConfirmed){
                        return;
                    }
                    Swal.showLoading();
                    API({method : 'post',url:'/Topup/'+Obj.TopupId+'/Refund',data:{Reson:0},headers: { "Content-Type": "multipart/form-data" }}).then(res=>{
                        if(!res.data.Status){
                            Swal.fire({
                                icon: 'error',
                                title: res.data.Message
                            });
                            return;
                        }
                        //_Load(res.data.Data.MemberId);
                        Swal.fire({
                            icon: 'success',
                            title: 'บันทึกสำเร็จ',
                        });
                        ref.current?.load();

                    }).catch(res => {
                        if(res.response.data != undefined){
                            Swal.fire({
                                icon: 'error',
                                title: res.code,
                                text: res.response.data.Message
                            });
                        }else{
                            Swal.fire({
                                icon: 'error',
                                title: 'การเชื่อมต่อผิดพลาด',
                                text: res.message+' ['+res.code+']',
                            });
                        }
                    });
                });
    }

    const _CloseCard = async()=>{

        Swal.fire({
            icon: 'warning',
            title: "ต้องการปิดบัตร เงินคงเหลือ "+NumberFormat(MemberDetail.Credit)+" บาท ?",
            text : 'รหัสประจำตัว '+MemberDetail.MemberCode,
            showCancelButton : true,
            confirmButtonText: 'ถูกต้อง',
            confirmButtonColor:'#d33',
            cancelButtonText:'ยกเลิก'
        }).then((r)=>{
            if(!r.isConfirmed){
                return;
            }
            setTimeout(()=>{
                Swal.showLoading();
                API({method : "post", url:"/Refund/"+localStorage.getItem("Shift")+"/"+MemberDetail.MemberId+"/"+(CardDetail != null ? CardDetail.CardNo : "00000000000000000000"),data: {}, headers: { "Content-Type": "multipart/form-data" }}).then(res=>{
                    if (!res.data.Status) {
                        Swal.fire({
                            title: res.data.Message,
                            icon: 'error'
                        });
                        return;
                    }
                    setMemberDetail(null);
                    setCardDetail(null);
                    _Search(CardSearch)
                    setTopup(null);
                    setTimeout(() => {
                        ref.current?.load();
                        refSearch.current?.focus();
                    }, 500);
                    Swal.close();
                }).catch(res => {
                    Swal.fire({
                        title: res,
                        icon: 'error'
                    });
                    return;
                });
            },200)
        });

    }
    return (
        <>
        <React.Fragment>
            <div className={(!ShiftStatus?"container-fluid min-vh-100 d-flex align-items-center justify-content-center":"container-fluid")}>
                {!ShiftStatus ? <>
                    <div className='row'>
                        <div className='col-12'>
                            <button 
                                type='button' 
                                className='btn btn-success btn-lg' 
                                style={{width: '150px'}} 
                                onClick={() => {_OpenShift();}}
                            >
                                เปิดรอบ
                            </button>
                        </div>
                    </div>
                        
                </> : 
                <>
                <div className='row justify-content-center mt-2 mb-2'>
                    <div className='col-lg-12 col-xl-8 col-md-12 col-sm-12 col-12'>
                        <div className='card'>
                            <div className='card-header'>
                                <div className='row'>
                                    <div className='col-10'>
                                        <h3 className=''>รอบวันที่ {(ShiftDetail != null ? DateThai(ShiftDetail.ShiftDate):'-')} เวลาเริ่ม {(ShiftDetail != null ? TimeFormat(ShiftDetail.ShiftTimeStart):'-')} </h3>
                                    </div>
                                    <div className='col-2'>
                                        <button className='btn btn-danger float-end' button='button' onClick={()=>{_CloseShift();}}>ปิดรอบ</button>
                                    </div>
                                </div>
                            </div>
                            <div className='card-body'>
                                <div className='row justify-content-center'>
                                    <div className='col-10'>
                                        <div className='card'>
                                            <div className='card-body'>
                                                <div className='row justify-content-center'>
                                                    <div className='col-10'>
                                                        <input type='text' ref={refSearch} className='form-control text-center fw-bold' placeholder='รหัสบัตร / รหัสเลขประจำตัว' value={CardSearch} onKeyDown={(e)=>{
                                                            if(e.key === 'Enter'){
                                                                setMemberDetail(null);
                                                                setCardDetail(null);
                                                                _Search(CardSearch)
                                                                setCardSearch('');
                                                                setTopup(null);
                                                            }
                                                        }} onChange={(e=>{setCardSearch(e.target.value)})} style={{background:'#67f5ba'}}/>
                                                    </div>
                                                </div>
                                                {MemberDetail != null?
                                                <>
                                                <div className='row mt-3'>
                                                    <div className='col-4'>
                                                        <img src={APIURL()+'/Files/Profile/'+MemberDetail.MemberId} style={{maxWidth:'200px',maxHeight:'200px;'}}/>
                                                    </div>
                                                    <div className='col-8'>
                                                        <div className='row'>
                                                            <div className='col-12'>
                                                                <h3>{MemberDetail.Name}</h3>
                                                            </div>
                                                            <div className='col-12 mt-3'>
                                                                <h5>รหัสประจำตัว : {MemberDetail.MemberCode}</h5>
                                                            </div>
                                                            <div className='col-12 mt-2 mb-2'>
                                                                <h5>ยอดเงินคงเหลือ : {NumberFormat(MemberDetail.Credit)}</h5>
                                                            </div>
                                                            <div className='col-12'>
                                                                <h5>แก้ไขล่าสุด : {DateThai(MemberDetail.Updated)}</h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='row mt-2 justify-content-center'>
                                                    <div className='col-4'>
                                                        <input type="text" ref={refTopup} className='form-control text-center fw-bold' style={{fontSize:'30px',background:'#e6aeb1'}} value={Topup} onChange={(e)=>{setTopup(e.target.value);}} onKeyDown={(e)=>{
                                                            if(e.key === 'Escape'){
                                                                e.preventDefault();
                                                                setTimeout(() => {
                                                                    setTopup('');
                                                                    refSearch.current?.focus();
                                                                }, 500);
                                                                return;
                                                            }
                                                            if(e.key === 'a' || e.key === 'A'){
                                                                e.preventDefault();
                                                                setTimeout(()=>{
                                                                    _Topup(20);
                                                                },200)
                                                                return;
                                                            }
                                                            if(e.key === 's' || e.key === 'S'){
                                                                e.preventDefault();
                                                                setTimeout(()=>{
                                                                    _Topup(25);
                                                                },200)
                                                                return;
                                                            }
                                                            if(e.key === 'd' || e.key === 'D'){
                                                                e.preventDefault();
                                                                setTimeout(()=>{
                                                                    _Topup(30);
                                                                },200)
                                                                return;
                                                            }
                                                            if(e.key === 'z' || e.key === 'Z'){
                                                                e.preventDefault();
                                                                setTimeout(()=>{
                                                                    _Topup(40);
                                                                },200)
                                                                return;
                                                            }
                                                            if(e.key === 'x' || e.key === 'X'){
                                                                e.preventDefault();
                                                                setTimeout(()=>{
                                                                    _Topup(50);
                                                                },200)
                                                                return;
                                                            }
                                                            if(e.key === 'c' || e.key === 'C'){
                                                                e.preventDefault();
                                                                setTimeout(()=>{
                                                                    _Topup(100);
                                                                },200)
                                                                return;
                                                            }
                                                            if(e.key === "Backspace" || e.key === "Tab" || e.key ==='.') return;

                                                            if(e.key === 'Enter'){
                                                                setTimeout(()=>{
                                                                    _Topup(Topup);
                                                                },200)
                                                            }
                                                            if(isNaN(e.key)) e.preventDefault();

                                                        }} 
                                                        />
                                                    </div>
                                                </div>
                                                <div className='row mt-5 justify-content-center'>
                                                    <div className='col-2 text-center'>
                                                        <button className='btn btn-success btn-lg  mr-2 ml-2' onClick={()=>{
                                                            setTimeout(()=>{
                                                                _Topup(Topup);
                                                            },200)
                                                        }}>เติมเงิน</button>
                                                    </div>
                                                    <div className='col-2 text-center'>
                                                        <button className='btn btn-info btn-lg mr-2 ml-2 text-white' onClick={()=>{
                                                           _MemberInfoCard.current?.Show(MemberDetail.MemberId);
                                                        }}>รายละเอียด</button>
                                                    </div>
                                                    <div className='col-2 text-center'>
                                                        <button className='btn btn-danger btn-lg mr-2 ml-2' onClick={()=>{
                                                           _CloseCard();
                                                        }}>ปิดบัตร</button>
                                                    </div>
                                                </div>
                                                
                                                </> 
                                                : ""
                                                }

                                                <div className='row mt-5'>
                                                    <div className='col-12 table-responsive'>
                                                        <table id="TransactionView" className='table w-100' role='grid'>
                                                                <thead>
                                                                    <tr>
                                                                        <th className="text-center textcenter">วันที่ / เวลา</th>
                                                                        <th className="text-center textcenter no-sort">รหัสประจำตัว</th>
                                                                        <th className="text-center textcenter no-sort">ชื่อ-นามสกุล</th>
                                                                        <th className="text-center textcenter">ยอดเงิน</th>
                                                                        <th className="text-center textcenter no-sortr">ยอดเงินคงเหลือ</th>
                                                                        <th className="text-center textcenter no-sortr">สถานะ</th>
                                                                        <th className="text-center textcenter no-sort">หมายเหตุ</th>
                                                                        <th className="text-center no-sort"></th>
                                                                    </tr>
                                                                </thead>
                                                                <DataTable TableID={"TransactionView"} Column={_column} Configs={_configs} ref={ref} ajax={_ajax} ColumnDefs={_ColumnDefs} />
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                
                            </div>
                        </div>
                    </div>
                </div>
                </>
                }
            </div>

            <Modal isOpen={_CloseShiftModel} className={'modal-xl'} centered={true} unmountOnClose={true}>
                <div className="modal-header">
                    <h5 className="modal-title">รอบวันที่ {(ShiftDetail != null ? DateThai(ShiftDetail.ShiftDate):'-')} เวลาเริ่ม {(ShiftDetail != null ? TimeFormat(ShiftDetail.ShiftTimeStart):'-')}</h5>
                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"  onClick={()=>{setCloseShiftModel(false)}}></button>
                </div>
                <div className='modal-body' style={{'minHeight':'500px'}}>
                    <div className='row justify-content-center'>
                        <div className='col-3'>
                            <h4>ยอดเติมเงิน</h4>
                        </div>
                        <div className='col-2'>
                            <h4  className='float-end'>{ShiftSummary != null ? NumberFormat(ShiftSummary.totaltopup):0.00}</h4>
                        </div>
                        <div className='col-2'>
                            <h4>บาท</h4>
                        </div>
                    </div>
                    <div className='row justify-content-center'>
                        <div className='col-3'>
                            <h4>จำนวนรายการ</h4>
                        </div>
                        <div className='col-2'>
                            <h4  className='float-end'>{ShiftSummary != null ? NumberFormat(ShiftSummary.counttopup):0.00}</h4>
                        </div>
                        <div className='col-2'>
                            <h4>รายการ</h4>
                        </div>
                    </div>

                    <div className='row justify-content-center mt-2'>
                        <div className='col-3'>
                            <h4>ยอดคืนเงิน</h4>
                        </div>
                        <div className='col-2'>
                            <h4  className='float-end'>{ShiftSummary != null ? NumberFormat(ShiftSummary.totalrefund):0.00}</h4>
                        </div>
                        <div className='col-2'>
                            <h4>บาท</h4>
                        </div>
                    </div>
                    <div className='row justify-content-center'>
                        <div className='col-3'>
                            <h4>จำนวนรายการคืนเงิน</h4>
                        </div>
                        <div className='col-2'>
                            <h4  className='float-end'>{ShiftSummary != null ? NumberFormat(ShiftSummary.countrefund):0.00}</h4>
                        </div>
                        <div className='col-2'>
                            <h4>บาท</h4>
                        </div>
                    </div>

                    <div className='row justify-content-center mt-3'>
                        <div className='col-3'>
                            <h4>ยอดเงินคงเหลือ</h4>
                        </div>
                        <div className='col-2'>
                            <h4  className='float-end'>{ShiftSummary != null ? NumberFormat(ShiftSummary.total):0.00}</h4>
                        </div>
                        <div className='col-2'>
                            <h4>บาท</h4>
                        </div>
                    </div>

                    <div className='row justify-content-center mt-5'>
                        <div className='col-6'>
                            <input className='form-control fw-bold text-center' placeholder='ยอดเงินคงเหลือปิดรอบ' type="number" style={{fontSize:'25px',background:'#f0c684'}} valu={ShiftAmount} onChange={(e)=>{setShiftAmount(e.target.value);}} />
                        </div>
                    </div>

                    <div className='row mt-5 justify-content-center'>
                        <div className='col-3 text-center'>
                            <button type='button' className='btn btn-success btn-lg' onClick={()=>{_CloseShiftAction();}}>ยืนยันปิดรอบ</button>
                        </div>
                    </div>
                </div>
            </Modal>
            <MemberInfoCard ref={_MemberInfoCard} />
            
        </React.Fragment>
        </>
    )
}

export default React.memo(StaffHome)